import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';

import { AuthService } from '../../../auth';
import { MenuItem } from '../../models';
import { MenuService, TranslationService } from '../../services';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.scss',
  imports: [RouterLinkActive, RouterLink, AsyncPipe],
})
export class SideMenuComponent extends BaseComponent implements OnInit {
  protected readonly translationService = inject(TranslationService);
  protected readonly menuService = inject(MenuService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  isAuthenticated$: Observable<boolean>;
  menuItems$: Observable<MenuItem[]>;

  ngOnInit() {
    this.isAuthenticated$ = this.authService.isAuthenticated();
    combineLatest([this.router.events, this.isAuthenticated$])
      .pipe(this.untilDestroyed())
      .subscribe(([event, isAuthenticated]) => {
        if (event instanceof NavigationEnd && isAuthenticated) {
          this.menuItems$ = this.menuService.menuItems(this.router.url);
        }
      });
  }
}
